/**
 * The one owner of the default generation-time evaluation anchor.
 *
 * Two independent literals used to assert the same coordinate without either
 * knowing about the other: `context.ts`'s `BOOTSTRAP_CONTEXT.referenceBandId`
 * (`'intermediate'`, which selects the SVP denominator via
 * `BalanceProfile.hpRef`) and `numeric/canonical-coordinator.ts`'s authoring
 * anchor (level `60` plus `V13_REFERENCE_GROWTH_X.intermediate`). They agreed,
 * but nothing derived one from the other or would have failed if one moved.
 *
 * They are one coordinate because the budget re-check is anchored to the
 * standard reference point by contract, and the band that point stands in is
 * the band its reference enemy belongs to. `V13_REFERENCE_GROWTH_X` puts the
 * three growth profiles' potency at parity exactly there, which is why it is
 * the anchor in the first place.
 *
 * This owns the *default* only. It is not a band-selection policy: a caller
 * that supplies an explicit `evalContext`/`balanceProfile` keeps it, and
 * nothing here derives a band from live owner state, current HP, or playtime.
 * `SkillBookSpec.referenceBandId` is a different axis (which reference
 * player's burst measurement gates legality) and is deliberately not tied to
 * this one.
 */

import { REFERENCE_LEVEL_TO_BAND } from './weapon-progression-v0.js';

export const CANONICAL_GENERATION_EVALUATION_ANCHOR = Object.freeze({
  level: 60 as const,
  band: REFERENCE_LEVEL_TO_BAND[60],
});
